import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { WEB_VERSION, formatWebBuildTooltip } from "../../version";

const BUILD_INFO_TOOLTIP_SX = {
  bgcolor: "#222",
  color: "#fff",
  minWidth: 220,
  px: "10px",
  py: "8px",
  borderRadius: "4px",
  fontSize: 12,
  lineHeight: 1.4,
  textAlign: "left",
  boxShadow: "0 2px 8px rgba(0,0,0,.35)",
};

// DEVP1-11919: the Zoho chat bubble floats in the bottom-left corner, so the
// label sits above it instead of behind it. Clears the bubble height plus its
// own offset from the viewport bottom.
const CHAT_BUBBLE_CLEARANCE = 96;

/**
 * Fixed bottom-left version label with build-info tooltip (semver + optional git SHA/time).
 */
export default function AppVersion() {
  return (
    <Box
      position="fixed"
      bottom={CHAT_BUBBLE_CLEARANCE}
      left={24}
      zIndex={10}
      display="inline-flex"
      alignItems="center"
      gap={0.5}
      sx={{ color: "text.secondary" }}
    >
      <Typography
        component="span"
        variant="caption"
        data-testid="app-version"
        sx={{ fontSize: "0.75rem", letterSpacing: "0.02em" }}
      >
        {`v${WEB_VERSION}`}
      </Typography>
      <Tooltip
        title={
          <Box component="span" sx={{ whiteSpace: "pre-line" }}>
            {formatWebBuildTooltip()}
          </Box>
        }
        placement="top-start"
        arrow={false}
        slotProps={{
          tooltip: {
            sx: BUILD_INFO_TOOLTIP_SX,
          },
        }}
      >
        <Box
          component="span"
          display="inline-flex"
          alignItems="center"
          sx={{ cursor: "help", lineHeight: 1 }}
        >
          <InfoOutlinedIcon
            fontSize="inherit"
            data-testid="app-build-info"
            aria-label="Build commit info"
            sx={{ fontSize: "0.85rem" }}
          />
        </Box>
      </Tooltip>
    </Box>
  );
}
